"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 *
 * @param {Array} requests - can handle more than one api requests in order.
 * Not recommended for responses that depend on previous response in the sequence
 * @param {Boolean} trigger
 * @param {Function} setTrigger
 *
 * Hook will make an api call when triggered.
 * @returns
 * FinalResponse - if api call is successful response will be an array for when multiple requests, object for single request, otherwise it will be null
 * error - if api call is not successful error will be an object otherwise it will be null
 * isLoading - loading state that will be useful for UI
 * setTrigger is a function that will update the trigger value.
 */
var useAxios = function useAxios(requests) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var setTrigger = arguments.length > 2 ? arguments[2] : undefined;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    response = _useState2[0],
    setResponse = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  (0, _react.useEffect)(function () {
    var unmounted = false;
    var source = _axios["default"].CancelToken.source();
    var apiCall = function apiCall() {
      setIsLoading(true);
      _axios["default"].all(requests.map(function (request) {
        return (0, _axios["default"])(_objectSpread(_objectSpread({}, request), {}, {
          cancelToken: source.token
        }));
      })).then(function (res) {
        if (!unmounted) {
          setResponse(res);
          setIsLoading(false);
          setTrigger(false);
        }
      })["catch"](function (error) {
        if (!unmounted) {
          setError(error);
          setResponse(null);
          setIsLoading(false);
          setTrigger(false);
        }
      });
    };
    if (trigger) {
      apiCall();
    }
    return function () {
      unmounted = true;
      source.cancel('Cancelling in cleanup');
    };
  }, [trigger]);
  var finalResponse = response;
  if (response && response.length === 1) {
    finalResponse = response[0];
  }
  return [finalResponse, error, isLoading];
};
var _default = exports["default"] = useAxios;
useAxios.propTypes = {
  /**
   * requests array that will be used to make the api call
   */
  requests: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    url: _propTypes["default"].string.isRequired,
    method: _propTypes["default"].oneOf(['post', 'get', 'put', 'delete']).isRequired,
    options: _propTypes["default"].object
  })).isRequired,
  /**
   * used to make api call
   */
  trigger: _propTypes["default"].bool.isRequired,
  /**
   * function that will handle the logic for the trigger value
   */
  setTrigger: _propTypes["default"].func.isRequired
};